import { Box, Text } from "@chakra-ui/react";
import type { ReactNode } from "react";

interface Props {
  children: ReactNode;
}

export const EspdGuidingMessage = ({ children }: Props) => (
  <Box borderLeft="3px solid" borderColor="smPrimary" pl="3" py="1" mb="3">
    <Text fontSize="sm">{children}</Text>
  </Box>
);
